import { render } from "./BiometricValidationView.vue?vue&type=template&id=1634cc38&scoped=true"
import script from "./BiometricValidationView.vue?vue&type=script&lang=js"
export * from "./BiometricValidationView.vue?vue&type=script&lang=js"

import "./BiometricValidationView.vue?vue&type=style&index=0&id=1634cc38&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1634cc38"]])

export default __exports__